import { FormControl, InputLabel, MenuItem } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import React from 'react';
import { WO2Select } from 'src/common';
import { GroupConsolidatedOption, MdaReportTypeField, UpdateGroupConsolidatedOption } from '../store/types';

interface Props {
  report: MdaReportTypeField;
  value?: GroupConsolidatedOption;
  setGroupConsolidatedOption?: ActionCreatorWithPayload<UpdateGroupConsolidatedOption>;
}

export const ReportGroupingOption = (props: Props): JSX.Element => {
  return (
    <FormControl sx={{ minWidth: 200 }}>
      <InputLabel id="group-id">Group Option</InputLabel>
      <WO2Select
        disabled={!props.setGroupConsolidatedOption}
        labelId="group-id"
        label="Group Option"
        onChange={(e) => {
          if (props.setGroupConsolidatedOption) {
            props.setGroupConsolidatedOption({
              report: props.report,
              option: e.target.value as GroupConsolidatedOption,
            });
          }
        }}
        value={props.value}
        defaultValue={GroupConsolidatedOption.UnderlyingClients}
      >
        <MenuItem value={GroupConsolidatedOption.Consolidated}>Consolidated</MenuItem>
        <MenuItem value={GroupConsolidatedOption.UnderlyingClients}>Underlying Clients</MenuItem>
        <MenuItem value={GroupConsolidatedOption.Both}>Both</MenuItem>
      </WO2Select>
    </FormControl>
  );
};
